import env from "@/env.mjs";
import { createDepict } from "@frend-digital/depict/server";

export const depict = createDepict({
  merchant: env.NEXT_PUBLIC_DEPICT_MERCHANT,
});
